import { Space, Spin } from 'antd'
import React from 'react'
import styles from './Loader.module.scss'

const Loader: React.FC = () => (
  <div className={styles['centered-div']}>
    <Space size='large'>
      <Spin size='large' />
    </Space>
  </div>
)

export default Loader
